export default __webpack_public_path__ + "i18n/translations/translation-kn.671113ab.json";